import React from "react";

import ECD from "../components/ECD";

const QC = (props) => {
    return (
        <div>
            <div class="container">
                <div class="row">
                    <div className="row customer-support text-center" style={{ marginTop: 10 }}>
                        <h4 style={{ color: "black" }}>{props.VehEntry.Veh_Year} {props.VehEntry.Veh_Make} {props.VehEntry.Veh_Model}</h4>
                        <p style={{ marginTop: 10, color: "black" }}>Quality Checks and Finishing Touches</p>
                        <p><b>{props.Veh_Year}</b></p>
                    </div>
                </div>
            </div>
            <div className="sec-title text-left" style={{ marginTop: 10 }}>
                <h4 style={{ color: "black" }}>What does this mean?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>We go through your repair order line by line and check all the work that we have done on your vehicle. We also check for things like fluid levels, lighting, and sensors that may have been unplugged during the repair process. If anything is found, we may send it back to the appropriate department to have touch-ups or repairs made. This phase generally takes about three to four hours to complete unless something is found during the check.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>What is next?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>If your vehicle has ADAS (Advanced Driver Assistance System) components that need to be recalibrated, then we will schedule to have a third party come to the shop and calibrate those components. These components include, but are not limited to, blind spot warning, lane departure warning, forward collision warning, adaptive cruise control, and automated parking. If your vehicle repair does not require any ADAS calibrations, your vehicle will be marked as ready to pick up and we will call you to let you know.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>Estimated Completion Date</h4>
                <span className="decor" />
                <ECD ecd={props.VehEntry.EstimatedCompletionDate} />
            </div>
        </div>
    )
}

export default QC